var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{attrs:{"id":"header"}},[_c('div',{staticClass:"inner"},[_c('div',{staticClass:"content"},[_c('router-link',{staticClass:"button big alt",attrs:{"to":{ name: 'Home', params: {} }}},[_c('span',[_vm._v("shutterwax")])])],1),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"button hidden",attrs:{"href":"#"}},[_c('span',[_vm._v("shutterwax")])])
}]

export { render, staticRenderFns }